import React, { useEffect, useState } from 'react';
import { Card } from '../../components/ui/Card';
import { Table, Tr, Td } from '../../components/ui/Table';
import { Badge } from '../../components/ui/Badge';
import { getBookings } from '../../api/bookings';
import { Booking } from '../../types';
import { formatCurrency, formatDate } from '../../utils/format';

export const AgentBookings: React.FC = () => {
  const [bookings, setBookings] = useState<Booking[]>([]);
  useEffect(() => { getBookings().then(r => setBookings(r.data.results || r.data)); }, []);

  return (
    <div>
      <h1 style={{ fontSize: 20, fontWeight: 500, marginBottom: 20 }}>Booking Saya</h1>
      <Card>
        <Table headers={['Kode', 'Hotel', 'Kamar', 'Tamu', 'Checkin', 'Checkout', 'Total', 'Status']}>
          {bookings.map(b => (
            <Tr key={b.id}>
              <Td><span style={{ fontFamily: 'monospace', fontSize: 11 }}>{b.booking_code}</span></Td>
              <Td style={{ fontSize: 12 }}>{b.hotel_name}</Td>
              <Td style={{ fontSize: 12 }}>{b.room_type}</Td>
              <Td style={{ fontSize: 12 }}>{b.guest_name}</Td>
              <Td style={{ fontSize: 12 }}>{formatDate(b.checkin_date)}</Td>
              <Td style={{ fontSize: 12 }}>{formatDate(b.checkout_date)}</Td>
              <Td style={{ fontWeight: 500 }}>{formatCurrency(b.total_price)}</Td>
              <Td><Badge status={b.status} /></Td>
            </Tr>
          ))}
        </Table>
      </Card>
    </div>
  );
};
